import dayjs from 'dayjs';
import Commons from '../../Services/Common/Common';
import Store from '../../Store/Store';
export const Home_Schema = {
  fields: {
    workEndForm: {
      workCd: { initial: '', label: '작업코드' },
      beforeImage: { initial: '', label: '종료 사진경로' },
      beforeComment: { initial: '', label: '종료 사유', required: 'Y' },
    },
  },

  mapper: {
    search1: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search2: {
      DepCd: (context) =>
        Commons.EncryptAES(context.depCd ?? context.userInfo?.depCd ?? ''),
      UserId: (context) => context.userInfo?.userid,
    },
    search3: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? ''),
    },
    save1: {
      SessionCd: (row) => Commons.EncryptAES(row.sessionCd.toString() ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
      CompleteYn: (row) => Commons.EncryptAES(row.completeYn ?? 'N') || '',
      SignImagePath: (row) => Commons.EncryptAES(row.signImagePath ?? '') || '',
      SignDate: (row) => Commons.EncryptAES(row.signDate ?? '') || '',
      IsSkipped: (row) => Commons.EncryptAES(row.isSkipped ?? 'N') || '',
      HostYn: (row) => Commons.EncryptAES(row.hostYn ?? 'N') || '',
      EntranceDt: (row) =>
        Commons.EncryptAES(row.entranceDt ?? dayjs().format('YYYY-MM-DD HH:mm:ss')) || '',
      ExitDt: (row) => Commons.EncryptAES(row.exitDt ?? '') || '',
      StayTime: (row) => Commons.EncryptAES(row.stayTime.toString() ?? '0') || '',
    },
    save3: {
      UserId: (_, context) => context.userInfo?.userid,
      WorkStopCd: (_, context) => Commons.EncryptAES(context.workStopCd),
    },
    save4: {
      WorkCd: (row) => Commons.EncryptAES(row.workCd),
      DepCd: (_, context) => Commons.EncryptAES(context.userInfo?.depCd),
      BeforeComment: (row) => Commons.EncryptAES(row.beforeComment),
      BeforeImage: (row) => Commons.EncryptAES(row.beforeImage),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
